import React from "react";
import { Form, InputNumber } from "antd";
import { useRootSelector } from "@/infrastructure/hooks";
import { BacktestAction, BacktestSel } from "@/features/backtest";
import { useDispatch } from "react-redux";

export default () => {
  const dispatch = useDispatch();
  const minCommission = useRootSelector(BacktestSel.minCommission);
  const commissionPct = useRootSelector(BacktestSel.commissionPct);

  return (
    <Form layout={"horizontal"}>
      <Form.Item
        label="Commission Rate (%)"
        name={"commissionPct"}
        rules={[{ required: true, message: "Please enter commission rate!" }]}
        initialValue={commissionPct}
      >
        <InputNumber
          style={{ width: "250px" }}
          min={0}
          max={100}
          step={0.1}
          onChange={e =>
            dispatch(
              BacktestAction.updateSetup({ commission: { min: minCommission, pct: e ? parseFloat(e as string) : 0 } })
            )
          }
        />
      </Form.Item>
      <Form.Item
        label="Minimum Commission ($)"
        name={"minCommission"}
        rules={[{ required: true, message: "Please enter minimum commission!" }]}
        initialValue={minCommission}
      >
        <InputNumber
          style={{ width: "250px" }}
          onChange={e =>
            dispatch(
              BacktestAction.updateSetup({ commission: { pct: commissionPct, min: e ? parseFloat(e as string) : 0 } })
            )
          }
        />
      </Form.Item>
    </Form>
  );
};
